module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IL-29d7d30a43c969a32224a69ad8f2dd24.png";